import http from 'common-module/src/util/http';

export async function loadProjects(data) {
  return http.post('/project/list', data);
}

// 通过项目ID获取功能开关-
export async function getProjectSwitches(id) {
  return http.get(`/project/${id}/switches`);
}

// 记录指引已操作信息
export async function guideRecord(step) {
  return http.post('/account/guide-record', { guideType: step });
}

export async function queryGuideInfo() {
  return http.post('/account/query-guide-info', {}, { showError: false });
}
export async function clearGuideInfo() {
  return http.post('/account/clear-guide-info', {});
}

export async function favoriteProjects(projectId, state) {
  if (state) {
    return http.post('/project/favorite-cancel', { id: projectId });
  }
  return http.post('/project/favorite', { id: projectId });
}

export const loadProjectList = async () => {
  return http.post('/project/list', {});
};

/**
 *
 * @param {Number} projectId 项目Id
 * @returns
 */
export const getProjectFeatureSwitches = async (projectId) => {
  const result = await http.get(`project/${projectId}/switches`);
  return { result };
};

/**
 *
 * @param {Array<number>} projectIds
 * @returns
 */
export const getProjectsFeatureSwitches = async (projectIds) => {
  return http.post('project/switches/batch-query', projectIds);
};

export const loadProjectsFeatures = async (ids) => {
  return http.post('/project/switches/batch-query', ids);
};

/**
 * 获取项目列表聚合接口
 * @param {*} data
 * @returns
 */
export const getProjectListAssemble = async (data) => {
  return http.post('/project-list/assemble', data);
};

/**
 * 保存项目列表header数据
 * @param {*} data
 * @returns
 */
export const saveProjectListHeader = async (data) => {
  return http.post('/list-table-header/projectList/save', data);
};

/**
 * 编辑项目概览
 * @param {*} data
 * @returns
 */
export const updateProjectOverview = async (data) => {
  return http.post('/project/edit', data);
};

/**
 * 修改項目自定義字段
 * @param {*} data
 * @returns
 */
export const updateCustomProjectOverview = async (data) => {
  return http.post('/project/edit-field-value', data);
};

/**
 * 獲取項目成員
 * @param {*} projectId
 * @returns
 */
export const getProjectMember = async (projectId) => {
  return http.post(
    '/member/project-users',
    { projectId, containAccUnEnabled: true },
    { showError: false }
  );
};

/**
 * 获取项目概览
 * @param {*} projectId
 * @returns
 */
export const getProjectOverview = async (projectId) => {
  return http.post('/project/overview', { projectId }, { showError: false });
};

// 判断是否有项目权限
export async function getUserPermission(data) {
  const result = await http.post('/project/user-project-permission', data);
  return { result };
}

/**
 * 获取项目列表聚合数据：项目列表、功能开关、最近访问
 * @param data
 * @returns {AxiosPromise | Promise<any>}
 */
export const projectAssembleList = (data) => {
  return http.post('/project/list-assemble', data, { showError: false });
};

/**
 * 获取项目用户聚合数据：项目用户列表、当前用户在项目中的角色信息
 * @param projectId
 * @returns {AxiosPromise | Promise<any>}
 */
export const projectUserAssemble = (projectId) => {
  return http.post(
    '/member/project-users-assemble',
    { projectId, containAccUnEnabled: true },
    { showError: false }
  );
};

/**
 * 忽略推荐的智能助理
 * @param {*} data
 * @returns
 */
export const cancelSmartSuggest = (data) => {
  return http.post('/automation/suggest/cancel', data, { showError: false });
};

/**
 * 保存推荐的智能助理
 * @param {*} data
 * @returns
 */
export const saveSmartSuggest = (data) => {
  return http.post('/automation/suggest/save', data, { showError: false });
};

/**
 * 手动获取推荐智能助理
 * @param {*} data
 * @returns
 */
export const getSmartSuggest = (data) => {
  return http.post('/automation/suggest/recommend', data, { showError: false });
};

/**
 * 添加智能助理
 * @param {*} data
 * @returns
 */
export const addSmart = (data) => {
  return http.post('/sys-automation/add', data, { showError: false });
};

/**
 * 获取时间组件节假日列表
 * @returns
 */
export const getHolidayList = async() => {
  return http.post('/org-holiday/list-holiday', {}, { showError: false });
};
